module.exports = __webpack_public_path__ + "static/media/waiting-event-confirmation.da05c056.svg";